import request, { appendApiUrl } from '@/utils/request'

// 获取用户的弹窗消息,并置为已读
export const getCrmWindow = (options = {}) => {
  const { kicoinId = '', pageType = 1 } = options
  return request.get(
    {
      url: appendApiUrl(
        `/user-message/crm-window?kicoinId=${kicoinId}&pageType=${pageType}`
      ),
    },
    {
      showErrorToast: true,
    }
  )

  // return Promise.resolve({
  //   id: '1641043',
  //   kicoinId: '1010252',
  //   userName: '',
  //   country: 'id',
  //   currency: 'Rp',
  //   messageId: '0',
  //   messageShow: 1,
  //   jumpUrl: '',
  //   messageRead: 1,
  //   taskStatus: 3,
  //   taskBeginTime: '1675326073',
  //   taskEndTime: '1677918073',
  //   createTime: '1675326073',
  //   updateTime: '1675326073',
  //   visible: true,
  //   messageType: 6,
  //   messageTitle: '弹窗消息',
  //   messageBody: '{"content":2,"buttonName":"点击我"}',
  // })
}
